import React, { Component } from 'react';
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { variables } from "./Variables.js"

import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import CsTable from './components/cstable.js';
export default class AssetItem extends React.Component {
    
    

    constructor(props) {
        super(props);
        this.state = {
            assetid: '',
            text:'',
            infoFields: [],
            refresh: true,
            canEdit:false
           
        }; 
        this.canEdit=false
        this.token = '';
        this.gridref = React.createRef();
        this.table = React.createRef();
        this.GridColDef = [
            {
                field: 'id',
                headerName: 'Field ID',
                width: 12,
                hide:true,
                editable: false,
            },
            {
                field: 'fieldheader',
                headerName: 'Field name',
                width: 150,
                editable: false,
            },
            {
                field: 'value',
                headerName: 'Value',
                width: 310,
                editable: true,
            }
        ];
        this.highlevel = true
        this.GridColDefRO = [
            {
                field: 'id',
                headerName: 'Field ID',
                width: 12,
                hide: true,
                editable: false,
            },
            {
                field: 'fieldheader',
                headerName: 'Field name',
                width: 150,
                editable: false,
            },
            {
                field: 'value',
                headerName: 'Value',
                width: 310,
                editable: false,
            }
        ];
    }


    getData(id) {
        return fetch(`${variables.API_URL}/api/assets/${id}/data`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.token,
            }
        })
            .then((response) => response.json()).then(data => this.setState({ infoFields: data }))
            .catch(() => { throw new Error('Data Loading Error'); });
    }

  
    setName(name) {
        this.assetid = name;
    }

    setNewId(id, txt, tkn, ce) {
       
        this.token = tkn
        this.canEdit = ce;
        this.setState({ assetid: id, text: txt, canEdit :ce});
        this.getData(id);
       
        console.log(id);
    }

    refresh() {
        this.setState({ refresh: !this.state.refresh });
    }
    click = () => {
        alert(this.state.infoFields[2].value);
    }


    changeAssetItem(e) {
        this.getData();
    }

    getFields() {

       return <div>
          

           

        </div>;

    }

    

    changed =(nr, or)  => {
        console.log(nr);
        if (this.state.canEdit == false) {
            return or;
        } 
        
        fetch(`${variables.API_URL}/api/assets/${nr.assetid}/data`,
            {

                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.token,
                },
                body: JSON.stringify(nr)
            }
             
        )
            .then(
                (response) => response.json()
            )
            .catch((e) => { console.error(e) });


        return nr;
    }

    getView = () => {
         
    }

    error(e) {
        console.log(e);
    }
    render() {
        if (this.state.assetid == 'V') {
            return (<CsTable selectedRoot={this.state.assetid}  ref={this.table} />)
        }
        else {
            return (<div>


                <TextField if="idass" value={this.state.assetid} onChange={this.changeAssetItem} />
                <Box sx={{ height: '600px', width: '600px' }}>

                    <h3>{this.state.text}</h3>
                    <DataGrid
                        className='datagrid'
                        columns={this.GridColDef}
                        rows={this.state.infoFields}
                        pageSize={30}
                        rowsPerPageOptions={[10]}

                        processRowUpdate={this.changed}
                        onProcessRowUpdateError={this.error}
                        experimentalFeatures={{ newEditingApi: true }}


                    />
                </Box>
            </div>)
        }
    }

    handleChange = (e) => {      
        this.setState({
            assetid: e.target.value          
        });
    }
}